import EditOrganization from './EditOrganization';

export default EditOrganization;



// WEBPACK FOOTER //
// ./src/components/forms/EditOrganizationForm/index.jsx